module.exports = __webpack_public_path__ + "static/media/4.ec4a9d2d.jpg";